import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from 'reactstrap';
import { MagstimColor, CurrentTheme, isPDA } from "common";


class MagstimInformationCard extends React.Component {

    render() {

        var button = <></>

        if (this.props.buttonIcon !== undefined && this.props.buttonIcon.length > 0) {
            button = <Button color="secondary" className="reset-btn" onClick={this.props.buttonClick} >
                <i className={this.props.buttonIcon}></i>
            </Button>
        }

        var dropdownFilter = <></>

        if(this.props.dropdownFilter !== undefined){
            dropdownFilter = <div className="flex-child medium-and-fixed">
                {this.props.dropdownFilter}
            </div>
        }

        return (
            <Wrapper className="ui-bg mb-2 h-100">
                <div className="flex-parent">
                    <div className="flex-child long-and-truncated">
                        <h2 className="d-none d-md-inline">{this.props.title}</h2>
                        <h3 className="d-md-none d-lg-none">{this.props.title}</h3>
                    </div>

                    <div className="flex-child short-and-fixed">
                        {button}
                    </div>

                    {dropdownFilter}
                </div>
                <div>
                    {this.props.children}
                </div>
            </Wrapper>
        );
    }
}

MagstimInformationCard.propTypes = {
    title: PropTypes.string,
    buttonIcon: PropTypes.string,
    buttonClick: PropTypes.func,
    dropdownFilter:PropTypes.element
};

MagstimInformationCard.defaultProps = {
    title: "",
    buttonIcon: "",
    buttonClick: undefined,
    dropdownFilter:undefined
};

const Wrapper = styled.div`

.flex-parent {
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 4px;
    color: ${MagstimColor.MagstimGroupHeaderText};
    background-color: ${MagstimColor.MagstimCardHeaderBackground};
    border-color: ${MagstimColor.MagstimCardHeaderBackground};
}

h2 {
    font-size: 1rem;
    font-weight: normal;
    margin: 8px 5px;
    line-height: 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    font-size: ${CurrentTheme().MagstimNavBarFontSize};
    font-weight: bold;
    color: ${MagstimColor.MagstimGroupHeaderText};
}

h3 {
    display: inline-block;
    margin: 8px 5px;
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    font-size: ${CurrentTheme().MagstimNavBarFontSizeSmall};
    font-weight: bold;
    color: ${MagstimColor.MagstimGroupHeaderText};
}

.long-and-truncated {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.short-and-fixed {
    white-space: nowrap;
    > div {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        display: inline-block;
    }
}

.medium-and-fixed {
    white-space: nowrap;
    > div {
        width: 220px;
        margin-right:16px;
    }
}


`;

export default isPDA() ? withRouter(MagstimInformationCard) : MagstimInformationCard;